import { useNavigate } from "react-router-dom";
import AppSteps from "../navigation/AppSteps";
import { useContext, useEffect, useState } from "react";
import { AmbientestModuleContext } from "../../context/AmbientestModuleContext";
import { useFieldArray, useForm } from "react-hook-form";
import FieldsetForm from "./FieldsetForm";
import { Button, Typography } from "@mui/material";
import InputFileImg from "../inputs/InputFileImg";
import { inputRequiredRule } from "../../helpers/form.helper";
import { InputField } from "../inputs/InputField";
import { UserDocumentFile, EnvDocAdditionalCode, EnviromentType, UserEnvDocSubmit } from "../../types";
import { CAT_DOCUMENTS } from "../../config";


const selfieGroupName: EnviromentType = 'selfie'
const idDocumentFormGroupName: EnviromentType = 'idDocument'
const additionalFormGroupName: EnviromentType = 'additional'

const formGroups = [selfieGroupName, idDocumentFormGroupName, additionalFormGroupName]

const actualStep = 3

export default function FormPlainEnviromentDocs() {
    const navigate = useNavigate()
    const context = useContext(AmbientestModuleContext)
    const { control, formState, handleSubmit, watch } = useForm()
    const [submitted, setSubmitted] = useState(false)
    const selfieArray = useFieldArray({
        control: control,
        name: selfieGroupName
    })
    const idDocumentArray = useFieldArray({
        control: control,
        name: idDocumentFormGroupName,
    })
    const additionalDocsArray = useFieldArray({
        control: control,
        name: additionalFormGroupName,
    })
    let documentSelected = watch('idDocumentType')

    function onSubmit(data: any) {
        let items: UserDocumentFile[] = []
        formGroups.forEach(group => {
            let groupFiles = (data as UserEnvDocSubmit)[group]
            if (groupFiles) {
                items = [...items, ...groupFiles]
            }
        })
        context?.setUserDocuments(items)
        setSubmitted(true)
    }

    useEffect(() => {
        if (selfieArray.fields.length === 0) {
            (CAT_DOCUMENTS.selfie[0].documents || []).forEach(item => {
                selfieArray.append({ ...item, img: null })
            })
        }
    }, [selfieArray.fields])

    useEffect(() => {
        let toClean = idDocumentArray.fields.length
        while (toClean >= 1) {
            idDocumentArray.remove(toClean - 1)
            toClean--
        }
        (CAT_DOCUMENTS.idDocument.find(d => d.name === documentSelected)?.documents || []).forEach(item => {
            idDocumentArray.append({ ...item, img: null })
        })
    }, [documentSelected])

    useEffect(() => {
        if (context?.formFields.requestAdditionalDocument?.length !== 0) {
            let toClean = additionalDocsArray.fields.length
            while (toClean >= 1) {
                additionalDocsArray.remove(toClean - 1)
                toClean--
            }
            (CAT_DOCUMENTS.additional.filter(item => item.documents.find(d => context?.formFields.requestAdditionalDocument?.includes(d.code as EnvDocAdditionalCode))) || []).forEach(item => {
                item.documents.forEach(doc => {
                    additionalDocsArray.append({ ...doc, img: null })
                })
            })
        }
    }, [context?.formFields.requestAdditionalDocument])

    useEffect(() => {
        if (submitted && context?.steps.length === actualStep) {
            context.requestUserEnviroment()
            setSubmitted(false)
        }
    }, [submitted, context?.steps])


    useEffect(() => {
        if (!context?.userData) {
            navigate(context?.path || '/')
        }
    }, [context?.userData])

    return (
        <div>
            <AppSteps steps={context?.steps || []} actualStep={actualStep} />
            <form
                className="form-contain business"
                onSubmit={handleSubmit(onSubmit)}
                autoComplete="off"
            >
                {context?.formFields.requestSelfie && <FieldsetForm title='Fotografia del trabajador'>
                    <div className='form-contain-row'>
                        <Typography component={'div'} variant='caption' color={'gray'} sx={{ marginTop: '0.5rem' }}>
                            Para adjuntar la fotografía, toma en cuenta lo siguiente:
                            <ul>
                                <li>Orejas y cejas deben ser visibles con una expresión neutra y sin lentes.</li>
                                <li>Debe tener una iluminación optima y un fondo despejado.</li>
                                <li>El archivo debe ser en formato JPG y con un peso minimo individual mínimo de 250kb.</li>
                            </ul>
                        </Typography>
                        {selfieArray.fields.map((field, index) => <div key={field.id}>
                            <InputFileImg
                                controller={{
                                    name: `${selfieGroupName}.${index}.img`,
                                    control: control,
                                    defaultValue: "",
                                    rules: { ...inputRequiredRule },
                                }}
                                fileTypes="image/jpeg,image/jpg"
                                errors={formState.errors}
                                label={`${(field as any).label}*`}
                                icon={(field as any).icon}
                            />
                        </div>)}
                    </div>
                </FieldsetForm>}
                {context?.formFields.requestIdDocument && <FieldsetForm title='Identificación del trabajador'>
                    <div className='form-contain-row'>
                        <Typography component={'div'} variant='caption' color={'gray'} sx={{ marginTop: '0.5rem' }}>
                            Para adjuntar el documento de identificación, toma en cuenta lo siguiente:
                            <ul>
                                <li>Debes subir ambos lados (si es requerido) en archivos por separado.</li>
                                <li>Cada archivo debe ser en formato JPG y con un peso minimo individual mínimo de 250kb.</li>
                            </ul>
                        </Typography>
                        <div className="m-auto">
                            <InputField
                                controller={{
                                    name: "idDocumentType",
                                    control: control,
                                    defaultValue: CAT_DOCUMENTS.idDocument[0].name,
                                    rules: { ...inputRequiredRule }
                                }}
                                errors={formState.errors}
                                options={CAT_DOCUMENTS.idDocument.map(d => ({ label: d.name, value: d.name }))}
                                label="Documento de identificación*"
                            />
                        </div>
                    </div>
                    <div className='form-contain-row'>
                        {idDocumentArray.fields.map((field, index) => <div key={field.id}>
                            <InputFileImg
                                controller={{
                                    name: `${idDocumentFormGroupName}.${index}.img`,
                                    control: control,
                                    defaultValue: "",
                                    rules: { ...inputRequiredRule },
                                }}
                                fileTypes="image/jpeg,image/jpg"
                                errors={formState.errors}
                                label={`${(field as any).label}*`}
                                icon={(field as any).icon}
                            />
                        </div>)}
                    </div>
                </FieldsetForm>}
                {context?.formFields.requestAdditionalDocument && <FieldsetForm title='Documentos adicionales'>
                    <div className='form-contain-row'>
                        <Typography component={'div'} variant='caption' color={'gray'} sx={{ marginTop: '0.5rem' }}>
                            Para adjuntar documentos adicionales, toma en cuenta lo siguiente:
                            <ul>
                                <li>Valida el nombre y correspondencia del documento solicitado con el que adjuntes.</li>
                                <li>Debes subir ambos lados (si es requerido) en archivos por separado.</li>
                                <li>Cada archivo debe ser en formato JPG y con un peso minimo individual mínimo de 250kb.</li>
                            </ul>
                        </Typography>
                    </div>
                    <div className='form-contain-row'>
                        {additionalDocsArray.fields.map((field, index) => <div key={field.id}>
                            <InputFileImg
                                controller={{
                                    name: `${additionalFormGroupName}.${index}.img`,
                                    control: control,
                                    defaultValue: "",
                                    rules: { ...inputRequiredRule },
                                }}
                                fileTypes="image/jpeg,image/jpg"
                                errors={formState.errors}
                                label={`${(field as any).label}*`}
                                icon={(field as any).icon}
                            />
                        </div>)}
                    </div>
                </FieldsetForm>}
                <div className="form-contain-row">
                    <div>
                        <Button
                            variant='outlined'
                            fullWidth
                            onClick={() => navigate(`${context?.path}/datos`)}
                        >
                            Cancelar
                        </Button></div>
                    <div>
                        <Button
                            type='submit'
                            className='app-btn-color'
                            fullWidth
                        >
                            Ambientar
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    )
}


